import { NotificationStatusEnum } from "@modules/notifications/model/INotifications";
import { NotificationTabKey } from "../../model";

export const { SCHEDULED, ACTIVE, EXPIRED, DELETED } = NotificationStatusEnum;

export const NotificationTabs: { key: NotificationTabKey; label: string }[] = [
  { key: SCHEDULED, label: "Programadas" },
  { key: ACTIVE, label: "Ativas" },
  { key: EXPIRED, label: "Expiradas" },
  { key: DELETED, label: "Excluídas" },
];

export const mappedLabelToStatus: Record<string, NotificationTabKey> = {
  programadas: SCHEDULED,
  ativas: ACTIVE,
  expiradas: EXPIRED,
  excluidas: DELETED,
};
